var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulge = function SvgBulge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.4054 13.7105H5.61299C5.61299 13.7105 1.5 13.637 1.5 8C1.5 2.363 5.55791 2.28955 5.61299 2.28955H10.4054C10.4054 2.28955 14.5184 2.363 14.5184 8C14.5184 13.637 10.4605 13.7105 10.4054 13.7105ZM10.4054 3.20763H5.61299C5.48446 3.20763 2.41808 3.29944 2.41808 8C2.41808 12.7006 5.48446 12.7924 5.61299 12.7924H10.4054C10.5523 12.7924 13.6003 12.6822 13.6003 8C13.6003 3.3178 10.5339 3.20763 10.4054 3.20763Z"
  })));
};
export default SvgBulge;